import { useEffect } from "react";
import { useSetAtom } from "jotai";
import { authStateAtom } from "@/stores/auth.atom";
import api from "@/lib/api/axios";
import { toast } from "@/components/ui/use-toast";
import { useNavigate } from "react-router-dom";

export default function DeauthorizeCallback() {
  const setAuthState = useSetAtom(authStateAtom);
  const navigate = useNavigate();

  useEffect(() => {
    const handleDeauthorize = async () => {
      try {
        // Clear tokens
        localStorage.removeItem("auth_token");
        localStorage.removeItem("refresh_token");
        
        // Update auth state
        setAuthState({
          user: null,
          isAuthenticated: false,
          isLoading: false,
          error: null
        });

        // Optional: Notify your backend about the deauthorization
        await api.post("/api/auth/deauthorize");
      } catch (error) {
        console.error('Deauthorization error:', error);
        toast({
          variant: "destructive",
          title: "Lỗi",
          description: "Có lỗi xảy ra khi xóa ủy quyền. Vui lòng thử lại sau.",
        });
        // Handle error or navigate to error page
        navigate("/login");
      }
    };

    handleDeauthorize();
  }, [setAuthState, navigate]);

  // No need to render anything as this is a callback endpoint
  return null;
} 